import { updateClientNameApi } from '../generated/clients/updateClientName';

const updateClientNameCustomApi = updateClientNameApi.enhanceEndpoints({
  endpoints: {
    updateClientName: {
      invalidatesTags: (_result, _error, { clientId }) => [
        { id: clientId, type: 'Clients' as const },
        { id: 'LIST', type: 'Clients' as const },
      ],
    },
  },
});

export const { useUpdateClientNameMutation } = updateClientNameCustomApi;
